import React, { Component } from 'react';
import { Header } from '../../components/index';
import { Heading2, Text, Heading3 } from '../../helper/Typography';
import { Container } from '../imprint/imprint';
import { SeoDataComponent } from '@lws/react-components';
import { mapMetaObject } from '../../helper/helperServices';

interface EntryPageProps {
  pageContext: {
    generalTexts: any;
    routeTexts: any;
    locale: string;
    id: string;
  };
}

class MSTeamsDataProtection extends Component<EntryPageProps> {
  render() {
    const {
      generalTexts,
      routeTexts: msteamsDataProtection,
      locale,
    } = this.props.pageContext;
    return (
      <main className={'App Light'}>
        <SeoDataComponent
          data={mapMetaObject(msteamsDataProtection.meta).data}
        />
        <Header
          darkTheme={false}
          lang={locale}
          pathname={this.props.location.pathname}
          generalTexts={generalTexts}
        />
        <Container>{locale === 'de' ? <De /> : <En />}</Container>
      </main>
    );
  }
}
const En = () => (
  <>
    <Heading2>Privacy Notice</Heading2>
    <Heading3>For Customers and Other Affected Parties</Heading3>
    <Text.p>
      With the following information, we aim to provide you with an overview of
      how we process your personal data and your rights under data protection
      law. The specific data processed and how it is used primarily depends on
      the services requested or agreed upon. Therefore, not all parts of this
      information will apply to you.
    </Text.p>

    <Text.p>You can download our privacy notice here (PDF):</Text.p>

    <Text.p>
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/20260817_Datenschutz_Information_Microsoft_Teams_ENG.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 17.08.2026{' '}
      </a>{' '}
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/20260501_Datenschutz_Information_Microsoft_Teams_ENG.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 01.05.2026{' '}
      </a>{' '}
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/Data_Privacy_Information_Microsoft_Teams_ENG.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 12.09.2025{' '}
      </a>{' '}
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/NGLB_MS_Teams_DS_20230307.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 07.03.2023{' '}
      </a>{' '}
    </Text.p>
  </>
);

const De = () => (
  <>
    <Heading2>Datenschutzhinweise</Heading2>
    <Heading3>Für Kunden und andere Betroffene</Heading3>
    <Text.p>
      Mit den folgenden Informationen möchten wir Ihnen einen Überblick über die
      Verarbeitung Ihrer personenbezogenen Daten durch uns und Ihre Rechte aus
      dem Datenschutzrecht geben. Welche Daten im Einzelnen verarbeitet und in
      welcher Weise genutzt werden, richtet sich maßgeblich nach den beantragten
      bzw. vereinbarten Dienstleistungen. Daher werden nicht alle Teile dieser
      Informationen auf Sie zutreffen.
    </Text.p>

    <Text.p>
      Sie können unsere Datenschutzhinweise hier downloaden (PDF):
    </Text.p>

    <Text.p>
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/20260817_Datenschutz_Information_Microsoft_Teams_DE.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 17.08.2026{' '}
      </a>{' '}
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/20260501_Datenschutz_Information_Microsoft_Teams_DE.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 01.05.2026{' '}
      </a>{' '}
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/Datenschutzhinweise_Microsoft_Teams_DE.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 12.09.2025{' '}
      </a>{' '}
      <br />
      <a
        style={{ textDecoration: 'underline' }}
        href="/pdf/NGLB_MS_Teams_DS_20230307.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        Microsoft Teams | 07.03.2023{' '}
      </a>{' '}
    </Text.p>
  </>
);

export default MSTeamsDataProtection;
